// extracted by mini-css-extract-plugin
export default {"container":"TextSecondary_container__6B-xz"};